import React from 'react'
import ActionHeader from './ActionHeader.js'
import StatusButtons from '.././components/buttons/statusButtons.js'

const TimedOutAction = props => {
    return (
        <div className="panel panel-status">
            <ActionHeader request={props.request} apiAuthHeaders={props.apiAuthHeaders} index={props.index} />
            <div className="col-xs-9">
                <div className="cb-stepper cb-canceled-step" data-cb-rstatus="canceled" data-cb-stepper-total="1"
                     aria-label="" role="region">
                    <ol>
                        <li className="cb-stepper-skip cb-stepper-active" data-cb-stepper-step="1">
                            <span aria-hidden="true" className="cb-glyph cb-glyph-circular cb-error"
                                  data-cb-stepper-glyph="cb-error"></span><p>{props.request.REQ_STATUS}</p><p></p><span
                            className="sr-only cb-stepper-step">step 1 of 1 active</span>
                        </li>
                    </ol>
                </div>
            </div>
            <StatusButtons apiAuthHeaders={props.apiAuthHeaders} PassDataItems={props.request} index={props.index} />
            <p>Because of some unexpected errors, we were not able to process your data. You can upload your data again
                through "Upload Full Replacement File" link or cancel your current request and create a new one.</p>
        </div>
    )
}
export default TimedOutAction
